import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca77b628"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Importacoes__Cabecalho" }
const _hoisted_2 = { class: "GrupoDeAcordeons" }

import { OTrilhaDeNavegacao } from "@/components/Gerais"
  import { MenuItem } from "primevue/menuitem"
  import OAcordeaoDeImportarArquivos from "@/components/Importacoes/OAcordeaoDeImportarArquivos/OAcordeaoDeImportarArquivos.vue"
  import { usarEscritorDeDados } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
  import AtividadesRepositorio from "@/repositorios/atividades/atividades.repositorio"
  import AtividadesPlanejadasRepositorio from "@/repositorios/eventos/eventos.repositorio"
  import { useI18n } from "vue-i18n"

  interface Props {
    rotaBase: MenuItem
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TImportacoes',
  props: {
    rotaBase: null
  },
  setup(__props: any) {

  

  const { t } = useI18n()

  const atividadesRepositorio = new AtividadesRepositorio()
  const atividadesPlanejadasRepositorio = new AtividadesPlanejadasRepositorio()
  const { escritor } = usarEscritorDeDados()

  const escritorDeImportacaoDeAtividadesPlanejadas = escritor<Blob, File>(
    atividadesRepositorio.importarAtividadesPlanejadas
  )

  const escritorDeImportacaoDeEventosPlanejados = escritor<Blob, File>(
    atividadesPlanejadasRepositorio.importarAtividadesPlanejadas
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(OTrilhaDeNavegacao), {
      "inicio-da-trilha": __props.rotaBase,
      "itens-da-trilha": []
    }, null, 8, ["inicio-da-trilha"]),
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(t)('importar')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(OAcordeaoDeImportarArquivos, {
        cabecalho: _unref(t)('atividadesPlanejadas'),
        class: "GrupoDeAcordeons__Atividades",
        escritor: _unref(escritorDeImportacaoDeAtividadesPlanejadas),
        "texto-estado-vazio": _unref(t)('importacoesDeTiposDeAtividade')
      }, null, 8, ["cabecalho", "escritor", "texto-estado-vazio"]),
      _createVNode(OAcordeaoDeImportarArquivos, {
        cabecalho: _unref(t)('eventosDeAtividadesPlanejadas'),
        class: "GrupoDeAcordeons__Eventos",
        escritor: _unref(escritorDeImportacaoDeEventosPlanejados),
        "texto-estado-vazio": _unref(t)('importacoesDeEventos')
      }, null, 8, ["cabecalho", "escritor", "texto-estado-vazio"])
    ])
  ]))
}
}

})